// The page's CSP nonce (ADR 0016). Imports nothing: the web's host reads it before any module runs (app/csp-nonce.ts).

/** The nonce of this page (Vite's `<meta property="csp-nonce">`); the browser hides the attribute, not the property. */
export function cspNonce(doc: Document = document): string | undefined {
  const meta = doc.querySelector<HTMLMetaElement>('meta[property=csp-nonce]');
  return meta?.nonce || meta?.getAttribute('nonce') || undefined;
}

/**
 * Gives style-injecting libraries the page's nonce: react-remove-scroll (Radix dialogs and menus) asks
 * get-nonce, which reads `__webpack_nonce__`. Without it their <style> tags are refused by the CSP.
 */
export function shareNonce(win: Window & typeof globalThis = window) {
  const nonce = cspNonce(win.document);
  if (nonce) (win as unknown as { __webpack_nonce__?: string }).__webpack_nonce__ = nonce;
}
